import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Letter } from '../../../../../../../../../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/components/List/components/Item/components/HighlightedText/components/Letter.js';
export const HighlightedText = ({
  text,
  query
}) => {
  const partedText = useMemo(() => text.split(new RegExp(`(${query})`, 'gi')), [text, query]);
  if (!query) {
    return text;
  }
  const normalizedQuery = query.toLowerCase();
  return partedText.map((part, index) => part.toLowerCase() === normalizedQuery ? _jsx(Letter, {
    children: part
  }, index) : part);
};